import * as React from "react";
import PropTypes from "prop-types";
import { Carousel } from "react-responsive-carousel";
import { nanoid } from "nanoid";

const HighlightImages = ({ images }) => {
  images = shuffle(images);
  images = images.slice(0, 10);

  return (
    <div className="content">
      <Carousel
        showArrows={true}
        infiniteLoop={true}
        showThumbs={false}
        showStatus={false}
        autoPlay={true}
        interval={6100}
      >
        {images.map((image) => {
          return (
            <div className="highlight-images" key={nanoid()}>
              {image &&
              image.image &&
              image.image.childImageSharp &&
              image.image.childImageSharp.resize ? (
                <img
                  src={image.image.childImageSharp.resize.src}
                  alt={basename(image.image.childImageSharp.resize.src)}
                />
              ) : null}
            </div>
          );
        })}
      </Carousel>
    </div>
  );
};

HighlightImages.propTypes = {
  images: PropTypes.array,
};

export default HighlightImages;

function shuffle(array) {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
}
function basename(path) {
  return path.split("/").reverse()[0];
}
